module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/c4-e7d88b7c404af7990f3a03f64f942df1.png";